import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}
    :host {
        display: flex;
        align-items: center;
        font-family: var(--sgdf-font-sans);
        color: var(--sgdf-color-default);
    }

    .container {
        height: 28px;
        width: 28px;
    }

    .round {
        position: relative;
    }

    .round label {
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 50%;
        cursor: pointer;
        height: 28px;
        left: 0;
        position: absolute;
        top: 0;
        width: 28px;
    }

    .round label:after {
        border: 2px solid #fff;
        border-top: none;
        border-right: none;
        content: '';
        height: 6px;
        left: 7px;
        opacity: 0;
        position: absolute;
        top: 8px;
        transform: rotate(-45deg);
        width: 12px;
    }

    .round input[type='checkbox'] {
        visibility: hidden;
    }

    .round input[type='checkbox']:checked + label {
        background-color: var(--checkbox-fill-color, currentcolor);
        border-color: var(--checkbox-fill-color, currentcolor);
    }

    .round input[type='checkbox']:checked + label:after {
        opacity: 1;
    }

    .checkbox__label {
        line-height: var(--sgdf-toggle-size-medium);
        margin-left: 0.5em;
        user-select: none;
    }
`;
//# sourceMappingURL=RoundCheckbox.styles.js.map